import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BillingRoutingModule } from './billing-routing.module';
import { RecurringInvoiceComponent } from './recurring-invoice/recurring-invoice.component';
import { BalanceCheckComponent } from './balance-check/balance-check.component';
import { InvoiceGenerationComponent } from './invoice-generation/invoice-generation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CombinedReportComponent } from './combined-report/combined-report.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectFilterModule } from 'mat-select-filter';
import {MatSelectModule} from '@angular/material/select';
import { RecurringInvoiceHistoryComponent } from './recurring-invoice-history/recurring-invoice-history.component';
import { CurrencyPipe } from '@angular/common';
import { OnceOffInvoiceComponent } from './once-off-invoice/once-off-invoice.component';
import { BillingPromotionComponent } from './billing-promotion/billing-promotion.component';
import { StatementReceiptCheckComponent } from './statement-receipt-check/statement-receipt-check.component';
import { PaymentDashboardComponent } from './payment-dashboard/payment-dashboard.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { ReportModalDialogComponent } from './report-modal-dialog/report-modal-dialog.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AdditionalFeaturesModule } from '../Additional-Features/Additional-Features.module';

@NgModule({
  declarations: [
    RecurringInvoiceComponent,
    BalanceCheckComponent,
    InvoiceGenerationComponent,
    CombinedReportComponent,
    ReportModalDialogComponent,
    RecurringInvoiceHistoryComponent,
    OnceOffInvoiceComponent,
    BillingPromotionComponent,
    StatementReceiptCheckComponent,
    PaymentDashboardComponent,
    ReportModalDialogComponent,
  ],
  imports: [
    CommonModule,
    BillingRoutingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatIconModule,
    MatSelectFilterModule,
    MatSelectModule,
    FormsModule,
    NgApexchartsModule,
    NgOtpInputModule,
    AdditionalFeaturesModule,
  ],
  providers: [
    CurrencyPipe ,
    DatePipe,
    MatPaginatorIntl
  ],
})
export class BillingModule { }
